import classNames from 'classnames';
import { TagBlock } from './TagsBuilder';
import { Tag } from './tags';

type WrappingTagsProps = {
  tags: Tag[];
  /** Callback when a tag is clicked */
  onClick?: (tag: Tag) => void;
  /** Additional class names for the container */
  className?: string;
  /** Use mini tag styling */
  miniTag?: boolean;
};

/**
 * WrappingTags - Simple flex-wrap tag display.
 *
 * No truncation, no measurement, no complexity - tags just wrap to the next line.
 * All tags are always visible.
 */
export const WrappingTags = ({
  tags,
  onClick,
  className,
  miniTag = false,
}: WrappingTagsProps) => {
  if (!tags || tags.length === 0) return null;

  return (
    <div
      className={classNames(
        'flex flex-wrap items-center',
        miniTag ? 'gap-0.5' : 'gap-1',
        className
      )}
    >
      {tags.map((tag, i) => (
        <TagBlock
          key={tag.id ?? i}
          hexColor={tag.colour}
          tagName={tag.name}
          onClick={onClick ? () => onClick(tag) : undefined}
          miniTag={miniTag}
        />
      ))}
    </div>
  );
};

export default WrappingTags;
